import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import api from '../../utils/api';

const B = '#0B3D6E', T = '#0F6E56';

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  // Fetch unread contacts count
  const { data: contactData } = useQuery({
    queryKey: ['admin-contacts-count'],
    queryFn: () => api.get('/contact').then(r=>r.data),
    refetchInterval: 30000
  });
  const unreadContacts = contactData?.unread || 0;

  const navItems = [
    { to:'/admin/dashboard', label:'Dashboard',   icon:'📊' },
    { to:'/admin/orders',    label:'Commandes',    icon:'📋' },
    { to:'/admin/products',  label:'Catalogue',    icon:'💊' },
    { to:'/admin/stock',     label:'Stock clients', icon:'📦' },
    { to:'/admin/contacts',  label:'Messages',     icon:'✉️', badge:unreadContacts },
    { to:'/admin/users',     label:'Clients',      icon:'👥' },
    { to:'/admin/settings',  label:'Paramètres',   icon:'⚙️' },
  ];

  const isActive = to => location.pathname === to;
  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <div style={{ minHeight:'100vh', background:'#f1f5f9', display:'flex', flexDirection:'column' }}>
      <header style={{ background:'#0f1f35', position:'sticky', top:0, zIndex:50 }}>
        <div style={{ display:'flex', alignItems:'center', padding:'0 1rem', height:54, gap:8 }}>
          <div style={{ display:'flex', alignItems:'center', gap:9, flexShrink:0, marginRight:6 }}>
            <div style={{ width:32, height:32, background:B, borderRadius:8, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="20" height="20" viewBox="0 0 40 40">
                <circle cx="20" cy="20" r="15" fill="none" stroke="white" strokeWidth="1.5" strokeDasharray="65 20"/>
                <rect x="14" y="17" width="12" height="6" rx="1.5" fill="white"/>
                <rect x="17" y="14" width="6" height="12" rx="1.5" fill={T}/>
              </svg>
            </div>
            <div style={{ lineHeight:1.15 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'#fff' }}>LOMED MEDICARE</div>
              <div style={{ fontSize:9, color:'rgba(255,255,255,0.45)', textTransform:'uppercase', letterSpacing:'0.8px' }}>Administration</div>
            </div>
          </div>

          <nav style={{ display:'flex', gap:2, flex:1, overflowX:'auto' }} className="admin-desktop-nav">
            {navItems.map(({ to, label, icon, badge }) => (
              <Link key={to} to={to} style={{ display:'flex', alignItems:'center', gap:5, padding:'7px 10px', borderRadius:8, textDecoration:'none', fontSize:12, position:'relative', whiteSpace:'nowrap', background:isActive(to)?'rgba(255,255,255,0.12)':'transparent', color:isActive(to)?'#fff':'rgba(255,255,255,0.55)', flexShrink:0 }}>
                <span>{icon}</span>{label}
                {badge > 0 && <span style={{ background:'#dc2626', color:'#fff', fontSize:9, fontWeight:700, width:16, height:16, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', position:'absolute', top:4, right:4 }}>{badge}</span>}
              </Link>
            ))}
          </nav>

          <div style={{ display:'flex', alignItems:'center', gap:8, flexShrink:0 }} className="admin-desktop-nav">
            <Link to="/" style={{ fontSize:11, color:'rgba(255,255,255,0.55)', textDecoration:'none', background:'rgba(255,255,255,0.07)', padding:'6px 10px', borderRadius:7, whiteSpace:'nowrap' }}>← Site</Link>
            <button onClick={handleLogout} style={{ display:'flex', alignItems:'center', gap:6, color:'rgba(255,255,255,0.6)', background:'rgba(255,255,255,0.07)', border:'none', padding:'6px 12px', borderRadius:8, fontSize:12, cursor:'pointer' }}>
              <svg viewBox="0 0 24 24" style={{ width:12, height:12, fill:'none', stroke:'currentColor', strokeWidth:2 }}><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
              {user?.username}
            </button>
          </div>

          <button onClick={()=>setMenuOpen(!menuOpen)} className="admin-mobile-nav" style={{ background:'rgba(255,255,255,0.1)', border:'none', borderRadius:7, padding:'6px 8px', cursor:'pointer', display:'flex', flexDirection:'column', gap:4 }}>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
            <span style={{ display:'block', width:18, height:2, background:'rgba(255,255,255,0.8)', borderRadius:2 }}/>
          </button>
        </div>

        {menuOpen && (
          <div style={{ background:'#162234', borderTop:'1px solid rgba(255,255,255,0.08)', padding:'8px' }}>
            {navItems.map(({ to, label, icon, badge }) => (
              <Link key={to} to={to} onClick={()=>setMenuOpen(false)} style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 12px', borderRadius:8, textDecoration:'none', fontSize:14, marginBottom:2, position:'relative', background:isActive(to)?'rgba(255,255,255,0.12)':'transparent', color:isActive(to)?'#fff':'rgba(255,255,255,0.65)' }}>
                <span>{icon}</span>{label}
                {badge>0 && <span style={{ background:'#dc2626', color:'#fff', fontSize:9, fontWeight:700, padding:'1px 6px', borderRadius:10, marginLeft:'auto' }}>{badge}</span>}
              </Link>
            ))}
            <button onClick={handleLogout} style={{ width:'100%', marginTop:4, background:'rgba(255,255,255,0.07)', border:'none', color:'rgba(255,255,255,0.65)', padding:'10px', borderRadius:8, fontSize:13, cursor:'pointer', textAlign:'left' }}>
              🚪 Déconnexion
            </button>
          </div>
        )}
      </header>

      <main style={{ flex:1 }}><Outlet/></main>

      <style>{`
        @media(min-width:640px){.admin-desktop-nav{display:flex !important}.admin-mobile-nav{display:none !important}}
        @media(max-width:639px){.admin-desktop-nav{display:none !important}.admin-mobile-nav{display:flex !important}}
      `}</style>
    </div>
  );
}

